module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_5010.280121df.png";